// redux/slices/cartSlice.js
import { createSlice } from "@reduxjs/toolkit";

const dishesSlice = createSlice({
  name: "Dishes",
  initialState: {
    selectedDishes: [], // Array to store selected dishes
  },
  reducers: {
    addDish: (state, action) => {
      // const { dish, quantity } = action.payload;
      const dish = action.payload;
      // console.log("action.payload", action.payload)
      console.log("dish", dish)
      // console.log("quantity", quantity)
      const existingDish = state.selectedDishes.find((item) => item.dish._id === dish._id);

      if (existingDish) {
        // Update quantity if the dish is already in the cart
        // existingDish.quantity += quantity;
        existingDish.quantity += 1;
      } else {
        // Add the dish to the cart if it's not there
        state.selectedDishes.push({ dish: dish, quantity: 1 });
      }
    },
    removeDish: (state, action) => {
      const { dishId } = action.payload;
      // console.log("dishId", dishId)
      state.selectedDishes.splice(dishId, 1); // Remove the dish when quantity is 0
      // const filterDish = state.selectedDishes.filter((dish) => dish.id !== dishId);
      // console.log("filterDish", filterDish)
      return state;
    },
    updateQuantity: (state, action) => {
      const { dish, quantity } = action.payload;
      const existingDishIndex = state.selectedDishes.findIndex((item) => item.dish._id === dish._id);
      console.log("existingDishIndex", existingDishIndex)
      if (existingDishIndex !== -1) {
        // const updatedDishes = [state.selectedDishes];
        // const updatedDishes = [...state.selectedDishes];
        state.selectedDishes[existingDishIndex].quantity -= 1

        if (state.selectedDishes[existingDishIndex].quantity === 0) {
          state.selectedDishes.splice(existingDishIndex, 1); // Remove the dish when quantity is 0
        }
      }
    },
    selectAllDishes: (state, action) => {
      const allDishes = action.payload

      console.log("allDishes", allDishes)
      for (const i of allDishes) {
        console.log(i)
        const existingDish = state.selectedDishes.find((dish) => dish.dish._id == i._id)
        if (existingDish) {
          existingDish.quantity += 1
        } else {
          state.selectedDishes.push({ dish: i, quantity: 1 })
        }
      }
    },
    removeAllDish: (state, action) => {
      const allDishes = action.payload
      const selectDishes = state.selectedDishes

      for (const i of allDishes) {
        const existingDishIndex = selectDishes.findIndex((dish) => dish.dish._id === i._id);

        if (existingDishIndex !== -1) {
          // Dish already exists, decrease quantity by 1
          state.selectedDishes[existingDishIndex].quantity -= 1;

          // If quantity becomes 0, remove the dish
          if (state.selectedDishes[existingDishIndex].quantity === 0) {
            state.selectedDishes.splice(existingDishIndex, 1);
          }
        } else {
          // Dish does not exist, add it to selectedDishes with quantity 1
          state.selectedDishes.push({
            dish: i,
            quantity: 1
          });
        }
      }




      // // state.selectedDishes = []
      // for (const i of allDishes) {
      //   console.log(i)
      //   const existingDish = selectDishes.findIndex((dish) => dish.dish._id == i._id)
      //   if (existingDish) {
      //     state.selectedDishes[existingDish].quantity -= 1
      //   } else {
      //     state.selectedDishes.push(null)
      //   }
      // }
      // state.selectedDishes = []
    }
  },
});

export const { addDish, removeDish, updateQuantity, selectAllDishes, removeAllDish } = dishesSlice.actions;
export default dishesSlice.reducer;
